import { Modal } from "antd"
import { ButtonGroup } from "../ButtonGroup"
import { useDispatch, useSelector } from "react-redux"
import { showModal } from "../../redux/modalSlice";
import { IRootState } from "../../redux/store";
import { REDIRECTION_URL } from "../../utils/constants";
import { EventMessageService } from "../../services/EventMessage";
import { StorageService } from "../../services/Storage";
import InsightService from "../../services/Insight";

export const QuitModal: React.FC = () => {
    const dispatch = useDispatch();
    const pepperOne = useSelector((state: IRootState) => state.params.value.pepperOne);

    const cancelProcess = () => {
        StorageService.deleteStorage();
        InsightService.logTrace('QuitModal', [
            { QuitModal: true },
            { ActiveQuit: true },
        ]);
        if (pepperOne) {
            EventMessageService.sendMessageEvent('cancel')
        } else {
            window.location.href = REDIRECTION_URL;
        }
    }

    return (
        <Modal className='quit-modal' open={true} closable={false} footer={
            <ButtonGroup
                continueMsg='Abandonar'
                cancelMsg='Volver al proceso'
                handleOk={cancelProcess}
                handleCancel={() => dispatch(showModal(false))}
            />
        }>
            <div className='quit-title'>¿Quieres abandonar el proceso?</div>
            <p>¿Estás seguro de que quieres abandonar el proceso de agregación financiera? Podrás perder todos los datos introducidos hasta el momento.</p>
        </Modal>
    )
}